import { OfficeTable } from '~/components/Landing/OfficeTable'

export default function OfficeTablePage() {
  return <OfficeTable />
}